<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" alt="" class="img-fluid" srcset="">
                    <h5 class="m-0">{{'DONT_HAVE_ACCOUNT' | translate }} &nbsp;<a (click)="onSignup()" class="fw-medium">{{'SIGN_UP' | translate}}!</a>
                    </h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4 fw-light">{{'PASSWORD_RESET' | translate }}</h2>
                    <h6>{{'RESET_PASSWORD_DESC' | translate}}</h6>
                    <form class="login-form" [formGroup]="resetPasswordForm" (ngSubmit)="form.form.valid"
                        #form="ngForm">
                        <div class="mb-3">
                            <mat-label>{{firstQuestion}} ?</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_ANSWER_PLACEHOLDER' | translate"
                                formControlName="firstQuestionAnswer">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || resetPasswordForm.get('firstQuestionAnswer')?.touched) && resetPasswordForm.controls['firstQuestionAnswer'].errors?.['required']">
                                {{'FIRST_QUESTION_ANSWER_REQUIRED_MSG' | translate}}
                            </mat-error>
                        </div>
                        <div class="mb-3">
                            <mat-label>{{secondQuestion}} ?</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_ANSWER_PLACEHOLDER' | translate"
                                formControlName="secondQuestionAnswer">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || resetPasswordForm.get('secondQuestionAnswer')?.touched) && resetPasswordForm.controls['secondQuestionAnswer'].errors?.['required']">
                               {{'SECOND_QUESTION_ANSWER_REQUIRED_MSG' | translate}} 
                            </mat-error>
                        </div>
                        <div class="mb-3">
                            <mat-label>{{thirdQuestion}} ?</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'WRITE_YOUR_ANSWER_PLACEHOLDER' | translate"
                                formControlName="thirdQuestionAnswer">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || resetPasswordForm.get('thirdQuestionAnswer')?.touched) && resetPasswordForm.controls['thirdQuestionAnswer'].errors?.['required']">
                                {{'THIRD_QUESTION_ANSWER_REQUIRED_MSG' | translate}}
                            </mat-error>
                        </div>
                        <div class="mb-3">
                            <!-- <p>By clicking on “Submit” we will verify your detail if the verification is successful then the link to regenerate the OTP will be sent to Email Address. -->
                            <!-- </p> -->
                        </div>
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="onSubmit()">{{'SUBMIT' | translate }}</button>

                    </form>
                </div>
            </div>

        </div>
        <div class="col-lg-5 p-0">
            <div class="image-height forgot-bg">
                <p>&nbsp;</p>
            </div>

        </div>
    </div>
</div>